import { useMemo } from 'react'
import { useRouter } from 'next/router'
import getFirstQueryString from '@/utils/getFirstQueryString'

export default function useServiceFromRouter (): string {
  const router = useRouter()

  return useMemo(() => {
    const { service } = router?.query || {}
    return getFirstQueryString(service)?.toLocaleUpperCase()
  }, [router?.query])
}
